<template>

    <div class="card mb-3 rounded-0 border-warning payment-card" v-if="title && title.length">
        <div class="card-body bg-white p-2">
            <div class="row">
                <div class="col-12 text-center font-weight-bold text-warning text-payment-card">
                    <div>   
                        <i class="bi bi-credit-card"></i> {{__('messages.to')}} <span class="h5">{{ months }}</span> {{title}}
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import { PaymentOptionsServices } from '../../services/PaymentOptionsService'

    export default {
        props: ['msiIsAvailible', 'summary'],
        data() {
            return {
                data: {},
                title: "",
                months: 0
            };
            
        },
        async mounted() {
            await this.getPayments();
        },
        methods: {
            async getPayments() {
                let response = await PaymentOptionsServices.GetPayment(this.summary);
                if (response) {
                    this.data = response;
                    let _title = (this.data.monthInterestFree && this.data.monthInterestFree.options?.length > 0  ? this.data.monthInterestFree.title : null) || "";
                    let splititle = _title.split(" ");
                    this.title = _title.substr(splititle[0].length +1, _title.length);
                    this.months = splititle[0];
                    if (this.msiIsAvailible.length > 0) {
                        this.months = Math.max(...this.msiIsAvailible);
                        this.title = this.__("messages.with_credit_card")
                    }
                }
                
            }
        },
        components: {
           
        }
    }
</script>
